import { render } from "./FAQList.vue?vue&type=template&id=3ab15ace&scoped=true"
import script from "./FAQList.vue?vue&type=script&lang=js"
export * from "./FAQList.vue?vue&type=script&lang=js"

import "./FAQList.vue?vue&type=style&index=0&id=3ab15ace&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab15ace"]])

export default __exports__